// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CommercialAgreementOffer } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/Offer';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

export const useCommercialAgreementOffers = <T = TemplateContract<CommercialAgreementOffer>[]>(
  select?: (data: TemplateContract<CommercialAgreementOffer>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryCommercialAgreementOffers', operator],
    queryFn: async (_, options) => {
      return ledgerApi.queryCommercialAgreementOffers(options, operator);
    },
    select,
  });
};
